import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function deleteCustomer(customerId, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(customerId)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(customerId) {
  const url = `${urls.deleteCustomer}${customerId}`
  const response = await Network.sendPostRequest(url, {})
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    return {
      success: true,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response.statusCode == 404
  ) {
    return {
      success: true,
      customerNotFound: true,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { deleteCustomer }
